export type SlackChannelReference = {
  id: string;
  name?: string;
};

export type TeamMetadataMapping = {
  teamTopic?: string;
  awsTeamTag?: string;
  slackTeamId?: string;
  slackChannelComms?: SlackChannelReference;
  slackChannelAlerts?: SlackChannelReference;
};

export const SLACK_WORKSPACE_BASE_URL =
  'https://moonpig-group.slack.com/archives';

export const TEAM_METADATA_ANNOTATIONS = {
  teamTopic: 'moonpig.com/team-topic',
  awsTeamTag: 'moonpig.com/aws-team-tag',
  slackTeamId: 'moonpig.com/slack-team-id',
  slackChannelCommsId: 'moonpig.com/slack-channel-comms-id',
  slackChannelCommsName: 'moonpig.com/slack-channel-comms-name',
  slackChannelAlertsId: 'moonpig.com/slack-channel-alerts-id',
  slackChannelAlertsName: 'moonpig.com/slack-channel-alerts-name',
} as const;
